<script lang="ts">
    import { onMount } from "svelte";
    import Sidebar from "./components/Sidebar.svelte";
    import Header from "./components/Header.svelte";
    import LoginForm from "./components/LoginForm.svelte";
    import Dashboard from "./components/Dashboard.svelte";
    import LoginEvents from "./components/LoginEvents.svelte";
    import Toaster from "./lib/components/Toaster.svelte";
    import { account, router, load } from "./lib/stores";
    import { deviceStats } from "./lib/stats";
    import { sidebarCollapsed } from "./lib/sidebar";

    let page = $router.page;
    let isAuthorized = $account.isAuthorized;

    router.subscribe((data) => (page = data.page));
    account.subscribe((data) => (isAuthorized = data.isAuthorized));

    onMount(() => {
        load();
    });
</script>

{#if !isAuthorized}
    <main class="min-h-screen flex items-center justify-center px-4">
        <div class="w-full max-w-sm">
            <LoginForm />
        </div>
    </main>
{:else}
    <Sidebar />
    <div
        class="min-h-screen flex flex-col transition-[margin] duration-150 {$sidebarCollapsed
            ? 'ml-14'
            : 'ml-56'}"
    >
        <Header
            onlineCount={$deviceStats.online}
            totalCount={$deviceStats.total}
        />
        <main class="flex-1 p-6">
            {#if page === "/dashboard" || page === "/"}
                <Dashboard />
            {:else if page === "/logins"}
                <LoginEvents />
            {/if}
        </main>
    </div>
{/if}

<Toaster />
